<template>
  <van-action-sheet
    v-model="showActionSheet"
    cancel-text="取消">
    <div class="share-content">
      <div class="title">立即分享给家长</div>
      <div class="img-nav" @click="prewView">
        <img :src="imageUrl ">
        <div class="preview-tips">查看海报</div>
      </div>
      <div class="tips">长按海报保存到本地</div>
    </div>
  </van-action-sheet>    
</template>
<script>
export default {
  name: "nofityBindAccount",
  data () {
    return {
      imageUrl: '',
      showActionSheet: false,
    }
  },
  methods:{
    getQrCodeImg() {
      return new Promise(async (resolve,reject) =>{

        

        let codeUrl = '';
        try {

          let res  = await this.$api.studentGetWechatInfo();
          if (res.code === 200)  {
            codeUrl = res.data.qrCodeUrl;
          } else {
            reject(new Error(res.msg || '网络异常，请稍后重试'));
          }
          if (res.code > 60000) {
            app.http.tipErr(res.msg || '网络异常，请稍后重试');
          }
        } catch (err) {
          reject(err)
        }
        

        const poster = app.getPoster({
          width: 482,
          height: 708,
          radius: 16,
          shapes: [
            {
              type: "img",
              render: "img",
              content: 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/parent-code.png',
              offset: {
                left: 0,
                top: 0,
                width: "w",
                height: "h",
              },
            },
            {
              type: "img",
              render: "img",
              content: 'data:image/jpeg;base64,' + codeUrl,
              offset: {
                top: 560,
                left: 195,
                width: 96,
                height: 96,
              },
            },
          ],
        });
        poster.getPng().then((url) => {
          this.imageUrl = url;
          resolve()
        })
        .catch(err=>{
          reject(err)
        }); 
      })
      
 
     
    },
    prewView() { 

      vant.ImagePreview({
        showIndex: false,
        className: 'show-poster-preview',
        images: [this.imageUrl],
      });
    },
    toBindAccount () {
      this.showLoading();
      this.getQrCodeImg()
        .then(()=>{
          this.showActionSheet = true;
        })
        .finally(()=>{
          this.$toast.clear();
        })
    },
  }
}
</script>
<style lang="scss" scoped>
.qrcode-container{
  transform: translate3d(-10000px,-10000px,-1px);
  position: absolute;
}
.share-content{
    max-height: 100%;
    overflow-y: auto;
  .title,
  .tips{
    margin: calc(var(--gap) * 20) auto calc(var(--gap) * 24);
    font-size:var(--fs-md);
    line-height:var(--lh-md);
    font-weight: 400;
    text-align: center;
  }
  .img-nav{
    position: relative;
    margin: auto;
    height: 354px;
    width: 241px;
    >img{
      outline: none;
      border: none;
      width: 100%;
      height: 100%;
    }
    .preview-tips{
      position: absolute;
      bottom: 0;
      left: 0;
      color: var(--white);
      padding: calc(var(--gap) * 5) calc(var(--gap) * 11);
      border-radius: 0 var(--radius-sm) 0 var(--radius-sm);
      background: rgba(var(--black-rgb), 0.8);
      opacity: 0.9;
    }
  }
  .tips{      
    margin: calc(var(--gap) * 8) auto calc(var(--gap) * 24);
    color: var(--g6);
  }
}
</style>